import { useContext } from 'react';
import { PreviewsContext } from '../contexts/PreviewsContext';

const usePreviews = () => useContext(PreviewsContext);

export default usePreviews;
